export const LOGIN_USERNAME_TOOLTIP_MESSAGE =
  "Email or Username \n\n Don't know the email address or username linked your profile?" +
  " Simply login with your cellphone number instead." +
  " We'll either send your details to your inbox or allow you to set a new email/username.";
export const LOGIN_USERNAME_TOOLTIP_POSITION = "bottom";
export const USERNAME_VALIDATION_ERROR_MESSAGE =
  "Please enter a valid login address.";
export const PASSWORD_VALIDATION_ERROR_MESSAGE =
  "Please enter a valid password.";
export const FORGOT_USERNAME_VALIDATION_ERROR_MESSAGE =
  "Enter a valid email or cellphone notification address.";
export const REGISTRATION_USERNAME_VALIDATION_ERROR =
  "Please enter a valid email address.";
export const REGISTRATION_USERNAME_NOTE =
  "This email address will become your Digital ID.";
export const REGISTRATION_CELLPHONE_VALIDATION_ERROR =
  "Cellphone number is invalid.";
export const REGISTRATION_FIRSTNAME_VALIDATION_ERROR =
  "First name must be at least 2 characters long.";
export const OTP_VALIDATION_ERROR = "Please enter a valid otp number";
export const BANNER_TITLE_LOGIN = "Welcome back!";
export const BANNER_TITLE_REGISTRATION = "Welcome!";
export const BANNER_MESSAGE_LOGIN = "Log in to manage your lines and services";
export const BANNER_MESSAGE_REGISTRATION = "Create your new Vodacom account";
export const DEFAULT_API_FAILURE_MESSAGE =
  "We are experiencing some technical difficulties right now. Please try again later.";
export const DEFAULT_API_FAILURE_TITLE = "Oops!";
export const DEFAULT_API_SUCCESS_TITLE = "Thank you";
export const RETRY_CAPTCHA_MESSAGE =
  "To get a new OTP, please select the checkbox to prove that you’re not a robot.";
export const EXCLAMATION_ICON_TYPE = "exclamation_mark";
export const COLOR_CLOSE_ICON_TYPE = "color-close";
export const SUCCESS_ICON_TYPE = "success";
export const INFORMATION_ICON_TYPE = "information";
export const CLOCK_ICON_TYPE = "clock";
export const REDIRECT_TO_PASSWORD_RESET = "forgotPassword";
export const COLOR_INFO_ICON_TYPE = 'color-info';
export const RED_INFO_ICON_TYPE = 'info-red';